import { useEffect } from 'react';
import Select from '../../../../juristec-ui/core/Select';
import { File } from '../types';

import {
  HeaderTips,
  FirstPageContainer,
  VarContainer,
  SelectContainer,
  SelectContainerFile,
} from './styled/SelectFileAndBindColumns.styled';

interface Variables {
  [key: string]: {
    description: string;
    type: string;
  };
}

interface SelectFileAndBindColumnsProps {
  variables: Variables;
  files: File[];
  selectedFile: {
    value: string;
    label: string;
    owner: string;
  };
  setSelectedFile: (file: { value: string; label: string; owner: string }) => void;
  selectedFileVars: Array<{
    value: string;
    label: string;
    type: string;
  }>;
  columnVarBinds: Record<string, string>;
  setColumnVarBinds: (
    binds: Record<string, string> | ((prev: Record<string, string>) => Record<string, string>)
  ) => void;
}

/**
 * First step for the 'CopyDashboard'. This is where the binding between columns and variables are made.
 */
const SelectFileAndBindColumns = ({
  variables,
  files,
  selectedFile,
  setSelectedFile,
  selectedFileVars,
  columnVarBinds,
  setColumnVarBinds,
}: SelectFileAndBindColumnsProps) => {
  const handleBinding = (variable: string, column: { value: string; label: string }) => {
    setColumnVarBinds((old) => ({ ...old, [variable]: column.value }));
  };

  function checkTypeColumn(el: { type: string }, columnType: string) {
    if (columnType === 'object' || columnType === 'category') {
      if (el.type === 'category' || el.type === 'object') return true;
      return false;
    }
    return el.type === columnType;
  }

  function isSelected(el: { value: string }, variable: string) {
    let aux = true;
    Object.keys(columnVarBinds).forEach((v) => {
      // n tirar opção da coluna da qual o valor foi selecionado. só dos outros selects
      if (v === variable) return;
      if (columnVarBinds[v] === el.value) aux = false;
    });

    return aux;
  }

  const checkColumn = (el: { value: string; type: string }, variable: string) => {
    if (!isSelected(el, variable)) return false;
    return checkTypeColumn(el, variables[variable].type);
  };

  useEffect(() => {
    if (selectedFileVars.length > 0) {
      const newBinds = { ...columnVarBinds };
      Object.entries(variables).forEach(([varName, varDetails]) => {
        // Find matching column by name and type
        const matchingColumn = selectedFileVars.find(
          (col) =>
            col.value.toLowerCase() === varName.toLowerCase() &&
            checkTypeColumn(col, varDetails.type),
        );
        if (matchingColumn && !columnVarBinds[varName]) {
          newBinds[varName] = matchingColumn.value;
        }
      });
      if (Object.keys(newBinds).length > Object.keys(columnVarBinds).length) {
        setColumnVarBinds(newBinds);
      }
    }
  }, [selectedFileVars, variables]);

  return (
    <FirstPageContainer>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', gap: '5px' }}>
        <SelectContainerFile>
          <Select
            placement="start"
            selectLabel="Arquivo para a cópia do dashboard"
            options={files.map((f) => ({
              ...f,
              id: f.file_id,
              value: f.file_id,
              label: f.filename!.replace('.metrics', ''),
            }))}
            // @ts-expect-error not typed yet
            value={selectedFile}
            // @ts-expect-error not typed yet
            onChange={setSelectedFile}
            placeholder="Selecione o arquivo"
            alphabeticalOrder
            isSearchable
            fullWidth
            atModal
          />
        </SelectContainerFile>
        <HeaderTips>
          <span style={{ fontSize: '13px' }}>
            Selecione abaixo as colunas do seu arquivo correspondentes as variáveis
            necessárias para a aplicação do template.
            {/* <span className="danger"> Observação: </span>
            A associação de variáveis
            que possuem outro significado em seu arquivo, pode gerar indicadores
            errados. */}
          </span>
        </HeaderTips>
      </div>
      <VarContainer>
        {Object.keys(variables)
          .sort((a, b) => a.localeCompare(b, 'pt-BR'))
          .map((variable) => (
            <SelectContainer key={variable}>
              <Select
                placement="start"
                selectLabel={variable}
                options={selectedFileVars.filter((i) => checkColumn(i, variable)) || []}
                // @ts-expect-error not typed yet
                value={{
                  id: columnVarBinds[variable],
                  label: columnVarBinds[variable],
                  value: columnVarBinds[variable],
                }}
                // @ts-expect-error not typed yet
                onChange={(columnSelected) => handleBinding(variable, columnSelected)}
                placeholder=""
                alphabeticalOrder
                isSearchable
                fullWidth
                atModal
              />
            </SelectContainer>
          ))}
      </VarContainer>
    </FirstPageContainer>
  );
};

export default SelectFileAndBindColumns;
